export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "OTA-Nachrichten aktivieren",
    installIntro:
      "Um Ihren Gästen von Booking.com / Airbnb aus WA Checkin zu antworten, müssen Sie die App",
    installIntroTail: "in der Unterkunft installieren.",
    installBtn: "OTA-Nachrichten installieren",
    installing: "Das Nachrichtenmodul wird installiert…",
    retryLink: "Ich habe die App bereits installiert, erneut prüfen",
    loading: "OTA-Nachrichten werden geladen…",
    empty: "Keine OTA-Nachrichten zu dieser Buchung.",
    modeAi: "KI",
    modeManual: "Manuell",
    predefinedHeader: "Schnellantworten",
    predefinedEmpty: "Keine passenden Antworten.",
    inputPlaceholder: "Nachricht schreiben oder / für Schnellantworten...",
    attachTitle: "Bild anhängen",
    senderGuest: "Gast",
    senderProperty: "Unterkunft",
    senderSystem: "System",
    senderUnknown: "Unbekannt",
    fileFallback: "Datei",
    toastTitle: "OTA-Nachrichten",
    errorTitle: "Fehler",
    loadError: "Die OTA-Nachrichten konnten nicht geladen werden.",
    modeErrorDetail: "Der OTA-Chat konnte nicht identifiziert werden. Laden Sie die Seite neu.",
    modeManualOnTitle: "Manueller Modus aktiviert",
    modeAiOnTitle: "KI-Agent aktiviert",
    modeManualOnDetail: "Sie beantworten die Nachrichten manuell",
    modeAiOnDetail: "Der Bot antwortet automatisch",
    modeChangeError: "Der Modus des OTA-Chats konnte nicht geändert werden",
    sendError: "Die OTA-Nachricht konnte nicht gesendet werden.",
    onlyImagesTitle: "Nur Bilder",
    onlyImagesDetail: "OTAs erlauben nur das Senden von Bildern.",
    imageTooBigTitle: "Bild zu groß",
    imageTooBigDetail: "Das Bild darf nicht größer als 5 MB sein.",
    installNoProperty: "Es wurde keine mit Channex verbundene Unterkunft gefunden.",
    installOk: "Anwendung erfolgreich installiert.",
    installError: "Die Anwendung konnte nicht installiert werden.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Interne Notiz schreiben…",
    saveHint: "⌘ / Strg + Enter zum Speichern",
    saving: "Wird gespeichert…",
    addNote: "Notiz hinzufügen",
    loading: "Notizen werden geladen…",
    emptyTitle: "Noch keine Notizen",
    emptyText: "Fügen Sie die erste interne Notiz über das Feld oben hinzu.",
    cancel: "Abbrechen",
    save: "Speichern",
    team: "Team",
    confirmDelete: "Löschen?",
    yes: "Ja",
    no: "Nein",
    editTitle: "Bearbeiten",
    deleteTitle: "Löschen",
    loadError: "Die Notizen konnten nicht geladen werden",
    added: "Notiz hinzugefügt",
    saveError: "Die Notiz konnte nicht gespeichert werden",
    updated: "Notiz aktualisiert",
    updateError: "Die Notiz konnte nicht aktualisiert werden",
    deleted: "Notiz gelöscht",
    deleteError: "Die Notiz konnte nicht gelöscht werden",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "Ausstehend",
    paidLabel: "Eingegangen",
    totalLabel: "Gesamt",
    loading: "Zahlungen werden geladen…",
    empty: "Es wurde noch keine Zahlung erfasst.",
    addPayment: "Zahlung hinzufügen…",
    fullyPaid: "Buchung vollständig bezahlt",
    recalcTitle: "Neu berechnen",
    sendWhatsappTitle: "Per WhatsApp senden",
    copyLinkTitle: "Link kopieren",
    editAction: "Bearbeiten",
    deleteAction: "Löschen",
    modalEditTitle: "Zahlung bearbeiten",
    modalAddTitle: "Zahlung hinzufügen",
    amountLabel: "Zu berechnender Betrag",
    fillRemaining: "Restbetrag berechnen ({amount})",
    methodLabel: "Zahlungsart",
    sendWhatsappCheck: "Den Link per WhatsApp an den Gast senden",
    noteLabel: "Notiz (optional)",
    notePlaceholder: "Z. B. Anzahlung, Zahlung bei Anreise…",
    cancel: "Abbrechen",
    save: "Speichern",
    generateLink: "Link erzeugen",
    registerPayment: "Zahlung erfassen",
    deleteConfirmTitle: "Diese Zahlung löschen?",
    deleteText1: "Die Zahlung wird gelöscht:",
    deleteLinkVoided: "Der Zahlungslink wird ungültig.",
    deleteIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteBtn: "Zahlung löschen",
    sendConfirmTitle: "Den Zahlungslink senden?",
    sendText1: "Dem Gast wird per WhatsApp der Link zur Zahlung von",
    sendBtn: "Link senden",
    methodCash: "Bar",
    methodCard: "Karte / Kartenterminal",
    methodTransfer: "Banküberweisung",
    methodOta: "Über OTA bezahlt",
    statusPaid: "Eingegangen",
    statusPending: "Ausstehend",
    statusFailed: "Fehlgeschlagen",
    statusCancelled: "Storniert",
    loadError: "Die Zahlungen konnten nicht geladen werden.",
    amountRequired: "Geben Sie einen Betrag ein.",
    saveError: "Die Zahlung konnte nicht gespeichert werden.",
    deleteError: "Löschen nicht möglich.",
    sendLinkError: "Der Link konnte nicht gesendet werden.",
    recalcError: "Neuberechnung nicht möglich.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Zimmer zuweisen",
    subWithUnitPre: "Dieser Buchung für",
    subWithUnitPost: "ist noch kein physisches Zimmer zugewiesen.",
    subNoUnit: "Dieser Buchung ist noch kein physisches Zimmer zugewiesen.",
    loading: "Verfügbarkeit wird geprüft…",
    freePre: "Verfügbare Zimmer für",
    freePost: "Wählen Sie eines aus und weisen Sie es direkt zu:",
    freeBadge: "Frei",
    assigning: "Wird zugewiesen…",
    occupiedNote:
      "{count} Zimmer an diesen Daten belegt | {count} Zimmer an diesen Daten belegt",
    noneFreeTitle: "Für diese Daten sind keine Zimmer frei.",
    noFreePre: "Alle Zimmer in",
    thisType: "dieser Kategorie",
    noFreeMid:
      "sind am {date} belegt oder gesperrt. Um diese Buchung zuzuweisen,",
    reorganizeBold: "ordnen Sie die Buchungen",
    noFreeMid2: "dieser Zimmerkategorie im Kalender neu (Schaltfläche",
    organizeBtn: "Organisieren",
    noFreeTail: "), um eines freizugeben.",
    tagMaintenance: "Wartung",
    tagBlocked: "Gesperrt",
    theseDates: "diese Daten",
    occupied: "Belegt",
    assignedOk: "Zimmer {label} erfolgreich zugewiesen.",
    assignError: "Das Zimmer konnte nicht zugewiesen werden.",
    notifyError: "Fehler",
    notifyDone: "Fertig",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Zimmer in dieser Buchung",
    typesCount: "{count} Kategorie | {count} Kategorien",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    guestsCount: "{count} Gast | {count} Gäste",
    totalLabel: "Gesamt",
    viewingBadge: "Angezeigt",
    noRoomAssigned: "Kein Zimmer zugewiesen",
    removeOneRoom: "Ein Zimmer entfernen",
    addOneRoom: "Ein Zimmer hinzufügen",
    confirmRemove: "Entfernen?",
    yes: "Ja",
    no: "Nein",
    cannotRemoveOnly: "Sie können das einzige Zimmer nicht entfernen",
    removeRoomFromBooking: "Dieses Zimmer aus der Buchung entfernen",
    updating: "Wird aktualisiert…",
    theChannel: "dem Kanal",
    otaManaged:
      "Dieses Zimmer wird von {channel} verwaltet: Anzahl und Preis werden dort geändert.",
    notifyError: "Fehler",
    notifyDone: "Fertig",
    qtyUpdated: "Anzahl aktualisiert",
    roomRemoved: "Zimmer aus der Buchung entfernt",
    updateError: "Die Buchung konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
  },
};
